export enum EmploymentTypeCode {
    Staff = 1,
    TravelOrContract = 2,
    PerDiem = 3,
    Marketing = 4,
    LocumTenens1099 = 7,
    LocumTenensW2 = 8,
    WorkforceDisruption = 9,
    AccessControl = 10,
    InterimLeadership = 11,
    Government = 12,
    Education = 13
}

export const lineOfBusinessWithoutOfferWorkflow = [
    EmploymentTypeCode.InterimLeadership,
    EmploymentTypeCode.LocumTenens1099,
    EmploymentTypeCode.LocumTenensW2
];

export const lineOfBusinessWithoutOfferWorkflowForLink = [
    EmploymentTypeCode.LocumTenens1099,
    EmploymentTypeCode.LocumTenensW2
];
